import cjs from './helpers/cjs';
import { rimg_shopify } from './rimg';
export default class DynamicCollectionList {
    constructor(section) {
        this.el = section.el;
        const collectionListImages = this.el.querySelectorAll('[data-collection-image]');
        cjs.onChange((breakpoints) => {
            if (breakpoints.previous.max('L') && breakpoints.current.value === 'S') {
                for (let i = 0; i < collectionListImages.length; i++) {
                    rimg_shopify.instance.update(collectionListImages[i]);
                }
            }
        });
    }
}
